<div class="invite-details">
  <a class="invite-details__back" routerLink="/jobseeker/applies/invitations">
    <svg-icon
      class="icon"
      src="/assets/icons/arrow-left.svg"
      [svgClass]="'chevron'"
    >
    </svg-icon>
    {{ 'label.BackToInvites' | translate }}
  </a>

  <app-spinner [isLoading]="isLoading$ | async" [isFixedPosition]="false">
    @if ({
      announcementDetails: announcementDetails$ | async,
      announcementInvitedJobseeker: announcementInvitedJobseeker$ | async,
      isJobseekerInvited: isJobseekerInvited$ | async,
      announcementNotFound: announcementNotFound$ | async,
      isLoading: isLoading$ | async,
      publishDate: publishDate$ | async,
      timeZone: timeZone$ | async,
      currentLanguage: currentLanguage$ | async
    }; as data) {
      @if (!data.isLoading && (data.announcementDetails?.expired || data.announcementNotFound)) {
        <div class="unavailable-ann">
          <app-not-existing-page
            [errorType]="errorType.NotAvailable"
            [hideDefaultMessage]="true"
          ></app-not-existing-page>

          <h4 class="unavailable-ann__title">
            {{ 'message.AnnouncementExpiredOrDoesNotExist' | translate }}
          </h4>
          <br />

          @if (data.announcementDetails?.similarAnnouncements?.length > 0) {
            <div class="expired-ann">
              <h4 class="expired-ann__text">
                {{ 'label.YouMayInterest' | translate }}:
              </h4>

              <div class="expired-similar-ann-container">
                @for (
                  announcement of data.announcementDetails?.similarAnnouncements;
                  track announcement.announcementId
                ) {
                  <div class="expired-similar-ann">
                    <div class="expired-similar-ann__title">
                      <a
                        class="expired-similar-ann__title-link"
                        [routerLink]="['/announcement', announcement?.announcementId]"
                        >{{ announcement?.title }}</a
                      >
                    </div>
                    <div class="expired-similar-ann__company-name">
                      {{ announcement?.customerName }}
                    </div>
                    <div class="expired-similar-ann__dates">
                      {{
                        announcement?.publishDate
                          | date: 'dd MMM':data.timeZone!:data.currentLanguage!
                      }}
                      -
                      {{
                        announcement?.deadlineDate
                          | date: 'dd MMM':data.timeZone!:data.currentLanguage!
                      }}
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
      @else if (data.announcementDetails !== null && data.isJobseekerInvited) {
        <hrra-announcement-details-tile
          [announcementDetails]="data.announcementDetails"
          [announcementInvitedJobseeker]="data.announcementInvitedJobseeker!"
          [isJobseekerInvited]="data.isJobseekerInvited"
          [publishDate]="data.publishDate!"
          [timeZone]="data.timeZone!"
          [currentLanguage]="data.currentLanguage!"
          [showInviteResponse]="true"
          (inviteRespond)="onInviteRespond($event)"
        ></hrra-announcement-details-tile>
      }
      @else if (!data.isLoading && data.announcementDetails !== null && !data.isJobseekerInvited) {
        <div class="not-invited-placeholder">{{ 'text.YouAreNotInvited' | translate }}</div>
      }
    }
  </app-spinner>
</div>
